<template>
	<SwitchOption
		class="alert-switch"
		optionColor="#929292"
		optionFontSize="12px"
		:option-name="switchTitle"
		:switch-model.sync="localValue"
	/>
</template>

<script>
import SwitchOption from '@/components/BlockEditorWidget/FieldSettings/FieldOptions/SwitchOption';
import VModelMixin from '@/mixins/VModelMixin';
export default {
	name: 'AlertSwitch',
	mixins: [VModelMixin],
	components: { SwitchOption },
	props: { switchTitle: { type: String } },
};
</script>

<style scoped lang="scss">
.alert-switch {
	font-size: 12px;
	padding-top: 16px;
}
</style>
